import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class PFKeys extends MainKeys {
    get place() {
        return Places.pf
    }
}

export default PFKeys
